// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import '@material/web/all.js';


// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

import '@material/web/all.js';


["turbo:load", "turbo:frame-load"].forEach(function(ev) {

  document.addEventListener(ev, function () {
    const chipSets = document.querySelectorAll('md-chip-set');

    chipSets.forEach((chipSet) => {   
      let form = chipSet.closest("form"); 

      if (form != undefined) {
        let required = chipSet.hasAttribute("required"),
            min = chipSet.getAttribute("minlength"),
            max = chipSet.getAttribute("maxlength");

        if (required) {
          form.addEventListener("submit", (event) => {
            let selected_size = 0;

            chipSet.querySelectorAll('md-filter-chip').forEach((chip) => {  
              if (chip.selected)
                selected_size = selected_size + 1;
            });

            if ((min > 0 && selected_size < min) || (max > 0 && selected_size > max) || (selected_size == 0)) {
              event.preventDefault();
              chipSet.classList.add('show-supporting-text');
            } else {
              chipSet.classList.remove('show-supporting-text');
            }

          });

        }

        chipSet.querySelectorAll('md-filter-chip').forEach((chip) => {  

          //CLICK
          chip.addEventListener("click", function () {
            var change_event = new Event('input');
            form.dispatchEvent(change_event);

            chip.querySelector("input").disabled = !chip.selected;

            //CODE FOR DESTROY ACTION
            if (chip.querySelector("input[type=checkbox]") != null) {
              console.log("chip:", chip)
              chip.querySelector("input[type=checkbox]").checked = !chip.selected;
              console.log("chip checkbox:", chip.querySelector("input[type=checkbox]").checked)
              
            }

          });

        });


        
      }

      
    });

    const dateInputs = document.querySelectorAll('md-filled-text-field[type=date], md-filled-text-field[type=datetime-local]');

    dateInputs.forEach((input) => {  
      input.addEventListener("click", () => {
        try {
          input.showPicker();
          // A date picker is shown.
        } catch (error) {
          // Use external library when this fails.
        }
      });

    });


    const selects = document.querySelectorAll('md-outlined-select');

    selects.forEach((select) => {  
      select.addEventListener('change', (e) => {
        let href = select.selectedOptions[0].dataset.href;

        console.log(href);
        if (href != undefined) {
          window.location.href = href;
        }
      });

    });

  });  

});

document.addEventListener('turbo:load', async e => {
  document.querySelectorAll(".auto-turbo-click").forEach(function (el) {
    Turbo.visit(el.getAttribute('href'), { frame: el.getAttribute('data-turbo-frame'), turbo: true });
  });

})

document.addEventListener('turbo:frame-render', async e => {
  if (['dashboard_frame'].includes(e.target.id)){
    if (document.location.href != e.detail.fetchResponse.location.href)
      history.pushState(history.state, '', await e.detail.fetchResponse.location)
  }
})

//window.addEventListener('popstate', () => Turbo.visit(document.location))


Turbo.StreamActions.redirect_to = function () {
  const url = this.getAttribute('url') || '/'
  Turbo.visit(url)
}